import React from 'react';
export default function BandanaSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <polygon points="6,16 34,16 28,30 12,30" fill="#1565C0" />
      <polygon points="10,16 30,16 26,26 14,26" fill="#1E88E5" />
      <circle cx="20" cy="21" r="2" fill="#FFF" opacity="0.3" />
      <circle cx="15" cy="22" r="1" fill="#FFF" opacity="0.2" />
      <circle cx="25" cy="22" r="1" fill="#FFF" opacity="0.2" />
    </svg>
  );
}
